var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "course-content": true, mobile: _vm.isMobile(_vm.$mq) } },
    [
      _c("div", { staticClass: "text" }, [
        _c("header", [
          _c("h4", [
            _vm.courseNumber
              ? _c("span", { staticClass: "course-number" }, [
                  _vm._v(_vm._s(_vm.courseNumber))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("span", [
              _c("strong", [_vm._v(_vm._s(_vm.course.name))]),
              _vm._v(" "),
              _vm.course.coming_soon
                ? _c("small", { style: { color: _vm.course.color } }, [
                    _vm._v(" Coming soon ")
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm.course.coming_soon && !_vm.courseDescription
            ? _c("div", { staticClass: "description" }, [
                _c("p", [_vm._v("Coming soon")])
              ])
            : _vm.courseDescription
            ? _c("div", {
                ref: "description",
                staticClass: "description",
                domProps: { innerHTML: _vm._s(_vm.courseDescription) }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.course.coming_soon && _vm.user.is_active
          ? _c(
              "button",
              {
                class: { btn: true, sending: _vm.isSendingNotifyRequest },
                attrs: {
                  disabled:
                    _vm.isSendingNotifyRequest ||
                    _vm.course.notify_when_published === true
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.sendNotifyRequest($event)
                  }
                }
              },
              [
                _c(
                  "transition",
                  { attrs: { name: "fade-fast", mode: "out-in" } },
                  [
                    _vm.course.notify_when_published
                      ? _c("span", [_vm._v(" We'll notify you ")])
                      : _c("span", [_vm._v(" Notify me ")])
                  ]
                )
              ],
              1
            )
          : _vm.course.coming_soon
          ? _c(
              "button",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    return _vm.$store.dispatch("signupModal/signup")
                  }
                }
              },
              [_vm._v("\n      Notify me\n    ")]
            )
          : _c("button", { staticClass: "btn black" }, [_vm._v("Go to course")])
      ]),
      _vm._v(" "),
      _vm.course.image_url
        ? _c("BriocheBackgroundImage", {
            staticClass: "img",
            attrs: { src: _vm.course.image_url, width: 200 }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }